import { Injectable } from '@angular/core';

import { WindowRef } from '../utils';

/**
 * This service can be used to let the browser show some data and use the given contentType/mimeType to show the data formatted.
 **/
@Injectable({
    providedIn: 'root'
})
export class ContentShowerService {

    constructor(private windowRef: WindowRef) {}

    showContent(content: string, contentType: string): void {
        if (!content) {
            return;
        }

        const nativeWindow = this.windowRef.nativeWindow;
        const mimeType = contentType || 'text/plain;charset=utf-8';
        const blob = new Blob([content], {
            type: mimeType
        });
        const url = URL.createObjectURL(blob);
        const newWindow = nativeWindow.open('', '_blank');

        if (!newWindow) {
            URL.revokeObjectURL(url);
            throw new Error('The browser blocked the new tab.');
        }

        // Avoid the new tab having access to the opener window for security reasons.
        newWindow.opener = null;

        newWindow.addEventListener('pagehide', () => URL.revokeObjectURL(url), { once: true });

        newWindow.location.href = url;
    }
}
